import * as React from 'react';
import { flow } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { IVehicle } from '../../../../../../data/api/models';
import Vehicle from '../Vehicle';

interface IVehiclesProps {
  count: number;
  vehicles: IVehicle[];
  fields: any;
  dispatch: any;
  change: any;
  renderDefinition: any;
  duplicateRegistration: number;
}

class Vehicles extends React.Component<IVehiclesProps> {

  public render() {
    const { fields, vehicles, dispatch, change, renderDefinition, duplicateRegistration } = this.props;

    return (
      <div>
        {fields.map((vehicle, index) => {
          return (
            <div key={index}>
              <Vehicle
                name={vehicle}
                vehicle={vehicles[index]}
                index={index}
                dispatch={dispatch}
                change={change}
                renderDefinition={renderDefinition}
                duplicateRegistration={duplicateRegistration === index}
              />
              {fields.length !== index + 1 && (
                <hr />
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const vehicles = selector(state, 'vehicles');

      return {
        quote: state.quote,
        vehicles,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(Vehicles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Quote/components/Vehicles/index.tsx